/* @flow */

import React from 'react';

import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';

import ButtonComponent from 'components/buttons/button';
import IntlMessageComponent from 'components/formatters/intlMessage';
import TwoFactorSetupComponent from 'app/users/twoFactorSetup';

type TwoFactorNudgeViewComponentProps = {
  dialogOpen: boolean;
  openDialog: () => void;
  closeDialog: () => void;
  completeSetup: () => void;
}

export default function TwoFactorNudgeViewComponent(props: TwoFactorNudgeViewComponentProps) {
  return (
    <Paper elevation={0}>
      <Box px={5} py={3}>
        <Alert variant="outlined" severity="info">
          <AlertTitle>
            <Box fontWeight="fontWeightBold"><IntlMessageComponent id="twofactor.nudge.title" /></Box>
          </AlertTitle>
          <IntlMessageComponent id="twofactor.nudge.text" />
          <Box mt={2}>
            <ButtonComponent
              color="primary"
              variant="contained"
              onClick={props.openDialog}
            ><IntlMessageComponent id="twofactor.nudge.button" /></ButtonComponent>
          </Box>
        </Alert>
      </Box>

      <Dialog open={props.dialogOpen} onClose={props.closeDialog} fullWidth maxWidth="sm">
        <DialogTitle><IntlMessageComponent id="twofactor.header" /></DialogTitle>
        <DialogContent>
          <TwoFactorSetupComponent
            onComplete={props.completeSetup}
            onCancel={props.closeDialog}
            cancelLabelId="general.cancel"
          />
        </DialogContent>
      </Dialog>
    </Paper>
  );
}
